import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DashboardStateModel, HealthRow, HealthRowMetric } from '../models/dashboard.model';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  getMockData(): Observable<DashboardStateModel> {
    const toMetric = (label: string, value: string): HealthRowMetric => ({ label, value });
    const row = (
      serviceName: string,
      status: 'healthy' | 'warning' | 'critical',
      aLabel: string,
      aValue: string,
      bLabel: string,
      bValue: string,
    ): HealthRow => ({
      serviceName,
      status,
      metricA: toMetric(aLabel, aValue),
      metricB: toMetric(bLabel, bValue),
    });

    const data: DashboardStateModel = {
      counts: {
        providers: 4,
        models: 12,
        agents: 3,
      },
      health: {
        rows: [
          row('API Gateway', 'healthy', 'Active Agents', '18', 'Response Time', '210ms'),
          row('Database', 'healthy', 'API Keys', '23', 'Success Rate', '98,2%'),
          row('AI Models', 'warning', 'Uptime', '99,9%', 'Error Rate', '1,8%'),
        ],
      },
    };
    return of(data);
  }
}
